import { connect } from 'react-redux';
import CardBody from './Body';
import { setMyAuthorizationConfirmationDialog } from '../../store/myAuthorizationsSlice';

const mapDispatch = {
  setMyAuthorizationConfirmationDialog,
};

export default connect(null, mapDispatch)(CardBody);
